import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { RecentTabsStoreType } from './types';

export const recentTabsStore = create(
  persist<RecentTabsStoreType>(
    (set) => ({
      recentTabs: [],
      setRecentTabs: (recentTabs) => set({ recentTabs }),
    }),
    {
      name: 'recent_tabs',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
